/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum IdeaProgress {
    PENDING = 'Pending',
    IN_PROGRESS = 'InProgress',
    DONE = 'Done',
    NOT_FEASIBLE = 'NotFeasible',
}
